import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {MatPaginatorIntl} from '@angular/material/paginator'
import {provideRouter, withHashLocation, withInMemoryScrolling} from '@angular/router'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {SpbPaginatorSv} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../environments/environment'
import {routes} from './app.routes'
import {ADMIN_ROLE, DOCUMENT, USER_ROLE, WINDOW} from './application/app'


const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: [USER_ROLE, ADMIN_ROLE]
}


export const appConfig: ApplicationConfig = {
  providers: [
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'Välkommen till administrations-tjänsten för verifiering av digitalt ID-kort. För att kunna använda tjänsten behöver du först identifiera dig med BankID.',
        buttonText: 'Logga in med BankID',
        route: ['/', 'admin']
      }
    },
    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline'
      }
    },
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    provideRouter(routes, withHashLocation(), withInMemoryScrolling({anchorScrolling: 'enabled'})),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    ),
    {provide: WINDOW, useValue: window},
    {provide: DOCUMENT, useValue: document},
    {provide: MatPaginatorIntl, useClass: SpbPaginatorSv}
  ]
}